export default {
    fmod: '',
    ptail: '',
    pcol: '',
    col_family: '',
    launch_research: false,
    reset_stock_list: false,
};